import React from "react";

const iconMap = {
 "Total Employees": "bi-people-fill",
 "Available": "bi-person-check-fill",
 "Busy": "bi-clock-history",
 "On Leave": "bi-calendar-event",
 "Utilization": "bi-speedometer",
 "Workload": "bi-graph-up"
};

const getBorderColor = (label) => {
 if (label === "Available") return "#28a745";
 if (label === "Busy") return "#ff8c00";
 if (label === "On Leave") return "#0d6efd";
 if (label === "Utilization") return "#6f42c1";
 if (label === "Workload") return "#6610f2";
 return "#ced4da";
};

const EmployeeStats = ({ stats = [] }) => {
 return (
 <div className="row g-3 mb-4" style={{ marginTop: "10px" }}>
 {stats.map((stat, index) => {
 const isPercent = stat.type === "percent";
 const valueText = isPercent ? `${stat.value}%` : stat.value;

 return (
 <div
 key={index}
 className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex"
 >
 <div
 className="bg-white rounded flex-grow-1 d-flex flex-column justify-content-between"
 style={{
 padding: "18px 20px",
 border: "1px solid #e4e8ef",
 borderLeft: `4px solid ${getBorderColor(stat.label)}`,
 minHeight: "110px" // bigger card
 }}
 >
 <div className="d-flex justify-content-between align-items-center mb-2">
 <div
 style={{
 fontSize: "0.9rem",
 color: "#6c757d",
 lineHeight: 1.2
 }}
 >
 {stat.label}
 </div>
 <i
 className={`bi ${iconMap[stat.label] || "bi-star"}`}
 style={{ fontSize: "1.3rem" }}
 ></i>
 </div>

 <div style={{ fontSize: "1.6rem", fontWeight: 700 }}>
 {valueText}
 </div>

 {isPercent && (
 <div className="progress mt-3" style={{ height: "5px" }}>
 <div
 className="progress-bar"
 role="progressbar"
 style={{
 width: `${stat.value}%`,
 background: getBorderColor(stat.label)
 }}
 ></div>
 </div>
 )}
 </div>
 </div>
 );
 })}
 </div>
 );
};

export default EmployeeStats;
